import React from 'react';
import { useTranslation } from 'react-i18next';
import georgiaflag from '../images/georgia-flag.png';

function Hero() {
    const{t, i18n} = useTranslation();
    return (
    <section id="hero" className="d-flex align-items-center">
        <div className="container position-relative text-center text-lg-left"  >
            <div className="row">
                <div className="col-lg-12">
                    <h1>
                        {t("welcome")} <span className="text-old">Old Tbilisi</span>
                    </h1>
                    <h1 className='text-old'>{t("enjoy")} <span>{t("georgisch")}</span><img className='georgia-flag' src={georgiaflag} alt="Georgisch Restaurant Old Tbilisi"/> {t("meal")}!</h1>
                    <a href="https://www.takeaway.com/be-en/menu/old-tbilisi-georgisch-restaurant" rel="noreferrer" target="_blank">{t("about-us-p-3")}</a>
                    <div className="btns">
                        <a href="#menu" className="btn btn-menu animated fadeInUp scrollto">{t("our-menu")}</a>
                        <a href="#book-a-table" className="btn btn-book animated fadeInUp scrollto">{t("book-a-table")}</a>
                    </div>
                </div>            
            </div>
        </div>
     </section>
    )
}

export default Hero;
